<template>
  <Modal 
    :id="'cmp-distribution-statement-calculate-ppu'" 
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('calculate_ppu_msg')}}</template>
    <template slot="body">
    
        <TextField
          class="m1"
          :id="'amount'"
          v-bind="textFieldConfig"
          :value="amount"
          :placeholder="$t('total_amount')"
          @valuechanged="onTextFieldValueChange"
        />     
   
    </template>
    <template slot="options">
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >{{$t('cancel')}}</button>
      <button
        class="dt-button v1 with-ico"
         :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="addNewamount"
      >
       {{$t('calculate_btn')}}
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';

export default {
  components: {
    Modal,
  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },

      amount:'',
      validationResult: {},
    };
  },
  mounted: function() {
    console.log("WERE",this.$route);
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }
  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this.amount=value
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    addNewamount: async function(e) {
      console.log()
      this.$emit('calculatePPU', { amount:this.amount ,statement_id:this.$route.params.statement_id });
    },
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-distribution-statement-calculate-ppu {
}
</style>